import { Box, styled } from "@mui/material";

export const StyledCompanyInfoCard = styled(Box)(({ theme }) => ({
  width: "30rem",
  borderRadius: "15px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  h1: {
    width: "100%",
    textAlign: "center",
    color: theme.contrast.dark,
    fontSize: "3.5rem",
  },
  ".row": {
    height: "1.8rem",
    display: "flex",
    gap: "3rem",
    alignItems: "center",
    paddingInline: "2rem",
    h4: {
      color: theme.contrast.dark,
      minWidth: "12.5rem",
      fontWeight: "bold",
    },
    ".text": {
      width: "5rem",
      minWidth: "0",
    },
  },
}));
